import { Pipe, PipeTransform } from '@angular/core';
import { ResortDetail } from '../models/presentation.model';

@Pipe({ name: 'resortAddress' })
export class OvsResortAddressPipe implements PipeTransform
{
    constructor()
    {
    }

    public transform(value: ResortDetail, digits?: string): any
    {
        if (!value)
            return "";

        let address: string = value.address1.trim();

        if (!String.isNullOrWhiteSpace(value.address2))
            address += ", " + value.address2.trim();

        if (!String.isNullOrWhiteSpace(value.address3))
            address += ", " + value.address3.trim();

        if (!String.isNullOrWhiteSpace(value.address4))
            address += ", " + value.address4.trim();

        let hasCity: boolean = !String.isNullOrWhiteSpace(value.city);
        let hasState: boolean = !String.isNullOrWhiteSpace(value.state);
        let hasZip: boolean = !String.isNullOrWhiteSpace(value.zip);

        if (hasCity || hasState || hasZip)
        {
            let cityStateZip: string = "";
            if (hasCity)
                cityStateZip += value.city.trim() + " ";

            if (hasState)
                cityStateZip += value.state.trim() + " ";

            if (hasZip)
                cityStateZip += value.zip.trim() + " ";

            address += ", " + cityStateZip.trim();
        }

        if (!String.isNullOrWhiteSpace(value.country))
            address += ", " + value.country;

        return address;
    }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/shared/resortAddress.pipe.ts